import types from './types';

const resetState = () => ({
  type: types.RESET_STATE,
});

const setEpisodeListStatus = episodeListStatus => ({
  type: types.SET_EPISODE_LIST_STATUS,
  payload: {
    episodeListStatus,
  },
});

const setEpisodePendingDeletion = episodePendingDeletion => ({
  type: types.SET_EPISODE_PENDING_DELETION,
  payload: {
    episodePendingDeletion,
  },
});

export default {
  resetState,
  setEpisodeListStatus,
  setEpisodePendingDeletion,
};
